import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import {
  toggleBulkInvitedModal,
  updatePagination,
  deSelectAllCandidate,
  setInvitedCandidatesLoading,
  fetchInvitedCandidates,
} from "@/reducers/client_candidates/candidatesinvited";
import { fetchCandidateTypes } from "@/reducers/clientdashboard";
import { _bulkImportInvitedCandidates } from "@/services/clientcandidates";
import { toastMessageText } from "@/utilities/CommonText";
import {
  showErrorToast,
  showSuccessToast,
  handleAPICatch,
} from "@/utilities/utils";

import ButtonLoader from "../../ButtonLoader";
/**
 * A component for bulk inviting candidates.
 *
 * @param {file} file - The file to be imported for bulk inviting candidates
 * @return {void}
 */
const BulkInviteCandidateModal = () => {
  const [bulkImporting, setBulkImporting] = useState(false);
  const dispatch = useDispatch();
  const { showBulkInvitedModal, filters, pagination } = useSelector(
    (state) => state.clientCandidatesInvited,
  );
  const [fileName, setFileName] = useState("");

  const { user } = useSelector((state) => state.clientProfile);

  /**
   * Function to handle the change event for a file input.
   *
   * @param {Object} file - the file object representing the selected file
   * @return {void}
   */
  const handleSubmit = (file) => {
    setBulkImporting(true);
    let response = _bulkImportInvitedCandidates({
      import_file: file.file,
    });
    response
      .then((res) => {
        if (res?.data?.data?.error_code == 0) {
          showErrorToast(
            "Provided an invalid file or a file in the wrong format.",
          );
          setBulkImporting(false);
          return;
        }
        showSuccessToast(
          "Bulk resume upload started. Resumes are being processed in the background.",
        );
        dispatch(
          updatePagination({
            ...pagination,
            currentPage: 1,
            isLastPage: false,
          }),
        );
        dispatch(fetchCandidateTypes());
        dispatch(deSelectAllCandidate());
        dispatch(setInvitedCandidatesLoading(true));
        dispatch(fetchInvitedCandidates(filters));
        setBulkImporting(false);
        dispatch(toggleBulkInvitedModal(false));
        setFileName("");
      })
      .catch((error) => {
        // console.log("error", error);
        handleAPICatch(error);
      })
      .finally(() => {
        setBulkImporting(false);
      });
  };
  const handleClose = () => {
    setFileName("");
    setBulkImporting(false);
    dispatch(toggleBulkInvitedModal(false));
  };
  const InviteForm = useRef();
  return (
    <ModalPopUp
      show={showBulkInvitedModal}
      panelClass="max-w-[550px]"
      onClose={() => {
        handleClose();
      }}
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <h3 className="text-[20px] font-semibold leading-[normal] text-black">
            Bulk Upload Resume
          </h3>
          <button
            onClick={handleClose}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        <div>
          <form
            // action={routingConstants.bulkInviteCandidate}
            // method="post"
            ref={InviteForm}
            // encType="multipart/form-data"
            // id="inviteForm"
            // onSubmit={(e) => {
            //   e.preventDefault();
            //   if (InviteForm.current) {

            //     // InviteForm.current.submit();
            //     // setBulkImporting(true);
            //   }
            // }}
          >
            <div className="flex flex-col gap-5">
              <div className="flex items-center gap-3">
                {/* <input type="hidden" name="_token" value={""} /> */}
                <input
                  type="file"
                  id="import_file"
                  name="import_file"
                  accept=".zip"
                  className="absolute left-0 top-0 opacity-0"
                  onChange={(e) => {
                    let name = e.target.files[0].name;
                    // validate extension
                    if (!name.match(/\.(zip)$/)) {
                      showErrorToast(toastMessageText.uploadOnlyZipFile, {
                        id: "bulk-invite-candidate-invalid-file",
                      });
                      return;
                    }

                    setFileName(e.target.files[0].name);
                  }}
                />
                <label
                  htmlFor="import_file"
                  className="transition-linear relative inline-flex h-[24px] cursor-pointer items-center whitespace-nowrap rounded-lg text-[14px] font-medium !text-primary underline underline-offset-4 hover:bg-none hover:opacity-75"
                >
                  Upload File
                </label>
                <p className="line-clamp-1 grow text-[14px] font-medium leading-[normal] text-black">
                  {fileName ? fileName : "No file chosen"}
                </p>
                <button
                  className="transition-linear relative inline-flex h-[36px] w-[78px] items-center rounded-lg border border-primary bg-primary px-4 text-[14px] font-medium !text-white hover:bg-none hover:!text-primary"
                  type="button"
                  onClick={() => {
                    if (fileName == "") {
                      showErrorToast(toastMessageText.selectFileToUpload, {
                        id: "bulk-invite-candidate-file-not-found",
                      });
                      return;
                    }
                    handleSubmit({
                      file: InviteForm.current.querySelector(
                        "input[name='import_file']",
                      ).files[0],
                    });
                  }}
                >
                  {bulkImporting ? <ButtonLoader /> : "Import"}
                </button>
              </div>
            </div>
            {/* <div className="mt-4 border-t border-t-lightblue pt-4">
              <a
                className="transition-linear relative inline-flex h-[36px] items-center rounded-lg border border-primary bg-primary px-4 text-[14px] font-medium !text-white hover:bg-none hover:!text-primary"
                href="/sample/bulk_candidate_invitation_sample.xlsx"
              // target="_blank"
              >
                Download Sample
              </a>
            </div> */}
          </form>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default BulkInviteCandidateModal;
